import { BrutusFeature } from "@app/api2/api";
import React from "react";
import { Dropdown } from "@/components/bp/bp-ui";


interface IBrutusFeatureSelectProps {
  name: string;
  value: BrutusFeature;
  onChange?: (ev, value: BrutusFeature) => void;
  readOnly?: boolean;
}

export const BrutusFeatureSelectSelect: React.FunctionComponent<IBrutusFeatureSelectProps> = (props) => {

  const brutusFeatures = [{ type: `${BrutusFeature.None}`, label: window.translation.brutus.featureNone }, { type: `${BrutusFeature.Mutations}`, label: window.translation.brutus.featureMutations }, { type: `${BrutusFeature.SilentAllele}`, label: window.translation.brutus.featureSilentAllele }]

  return props.readOnly ? <>{brutusFeatures.find(x => x.type == `${props.value}`)?.label}</> : <Dropdown
    name={props.name}
    scrolling selection
    onChange={(ev, { value }) => {
      if (props.onChange)
        props.onChange(ev, value as BrutusFeature);
    }}
    options={[...brutusFeatures.map((type) => { return { key: type.type, value: type.type, text: type.label }; })]}
    value={props.value}>
  </Dropdown>
};

